export const getChamberRoomTitle = (chosenChamberRoomId, allChamberRoomsOfThisClinicLocation) => {
  const seletedChamber = allChamberRoomsOfThisClinicLocation?.find(
    (item) => item?.id === chosenChamberRoomId,
  )

  return seletedChamber?.title || chosenChamberRoomId
}

